import config from './../config'

const baseUrl = config.baseUrl

export default baseUrl